import {
    FIFTY_DISCOUNT,
    THIRTY_DISCOUNT,
    TEN_DISCOUNT,
    IS_CONTINUE,
    COMMON,
    DELETE_CONFIRM,
    IS_DELETE_CONTINUE,
    PROHIBITED_ITEM,
    NBPBKBN,
    EXCEL_VALIDATION,
    SHOW_TABLE_LIMIT_OVER,
    BAIKA,
    EXPORT_ERROR,
    VARIANT_PRODUCTS,
    IS_VARIANT_PRODUCTS_CONTINUE,
    SHOW_LINKED_ITEM,
} from '../actions/type';

const initialState = {
    isContinue: false, // 申請・編集続行
    // 50%乖離
    fiftyDiscount: {
        isShow: false,
        items: [],
    },
    // 30%乖離
    thirtyDiscount: {
        isShow: false,
        items: [],
    },
    // 10%乖離
    tenDiscount: {
        isShow: false,
        items: [],
    },
    isDeleteContinue: false, // 削除続行
    deleteConfirm: false, // 削除確認
    // 下限値超過
    showTableLimitOver: {
        isShow: false,
        items: [],
    },
    // 禁止商品
    prohibitedItem: {
        isShow: false,
        items: [],
    },
    // PB/留型
    nbpbkbn: {
        isShow: false,
        items: [],
    },
    // 売価
    baika: {
        isShow: false,
        items: [],
    },
    // Excelバリデーション
    excelValidation: {
        isShow: false,
        items: [],
    },
    // 共通
    common: {
        isShow: false,
        title: '',
        body: '',
    },
    exportError: {
        isShow: false,
        title: 'ダウンロードエラー',
        text01: '１度にダウンロードできる件数は7,000件です。期間を変更してお試しください。',
    },
    // 類似商品
    variantProducts: {
        isShow: false,
        items: [],
    },
    // 類似商品続行
    isVariantProductsContinue: false,
    // 連動商品登録表示
    showLinkedItem: false,
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case IS_CONTINUE:
            return {
                ...state,
                isContinue: action.data,
            };
        case FIFTY_DISCOUNT:
            return {
                ...state,
                fiftyDiscount: action.data,
            };
        case THIRTY_DISCOUNT:
            return {
                ...state,
                thirtyDiscount: action.data,
            };
        case TEN_DISCOUNT:
            return {
                ...state,
                tenDiscount: action.data,
            };
        case SHOW_TABLE_LIMIT_OVER:
            return {
                ...state,
                showTableLimitOver: action.data,
            };
        case PROHIBITED_ITEM:
            return {
                ...state,
                prohibitedItem: action.data,
            };
        case NBPBKBN:
            return {
                ...state,
                nbpbkbn: action.data,
            };
        case EXCEL_VALIDATION:
            return {
                ...state,
                excelValidation: action.data,
            };
        case IS_DELETE_CONTINUE:
            return {
                ...state,
                isDeleteContinue: action.data,
            };
        case DELETE_CONFIRM:
            return {
                ...state,
                deleteConfirm: action.data,
            };
        case COMMON:
            return {
                ...state,
                common: action.data,
            };
        case BAIKA:
            return {
                ...state,
                baika: action.data,
            };
        case EXPORT_ERROR:
            return {
                ...state,
                exportError: action.data,
            };
        case VARIANT_PRODUCTS:
            return {
                ...state,
                variantProducts: action.data,
            };
        case IS_VARIANT_PRODUCTS_CONTINUE:
            return {
                ...state,
                isVariantProductsContinue: action.data,
            };
        case SHOW_LINKED_ITEM:
            return {
                ...state,
                showLinkedItem: action.data,
            };
        default:
            return state;
    }
};

export { modalReducer };
